import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PendingCoachReviewModal from '../PendingCoachReviewModal';
import { manageDisableScrolling } from '../../ducks/ui.duck';

/**
 * Global host for the post-login customer review prompt (mounted beside Routes, not only in Topbar).
 */
const CustomerReviewPromptHost = ({ currentUser, onManageDisableScrolling }) => {
  if (!currentUser?.id) {
    return null;
  }
  return (
    <PendingCoachReviewModal
      currentUser={currentUser}
      onManageDisableScrolling={onManageDisableScrolling}
    />
  );
};

const mapStateToProps = state => ({
  currentUser: state.user?.currentUser,
});

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(CustomerReviewPromptHost);
